import { memo, useEffect, useState } from "react";

const ImageFetch = ({link,addAssets,selectedCategory,incrementLoader,imagesLoaded,reRender}) =>{
    const [image,setImage] = useState(null)
    useEffect(()=>{
        setImage(null)
    },[link])
    const loadImage = async () => {
        try {
          const response = await fetch(link,{headers:{'Cache-Control':'no-cache'}});
          const blob = await response.blob();
          incrementLoader()
          const dataUrl = URL.createObjectURL(blob);
          setImage(dataUrl)
        } catch (error) {
          console.error("Error loading image:", error);
        }
      };
      useEffect(()=>{
        if(!image){
          loadImage()
        }
      },[image])
      return (
        <div
                  onClick={() => {
                    addAssets({
                      image
                    });
                  }}
                  style={{cursor:"pointer",width:"150px"}}
                  className={image?"profile-avatar":""}
                >
                 
                  <img src={image} alt="" />
                </div>
      )
}
export default ImageFetch